import { millisecondsInDay } from 'date-fns/constants';

/**
 * Whole days in a millisecond span, discarding any partial day.
 *
 * date-fns ships `millisecondsToHours`/`Minutes`/`Seconds` but no day equivalent. Note this floors
 * rather than truncating towards zero the way those siblings do, so a negative span rounds DOWN
 * (`-1.5` days reads as `-2`). That is the behaviour the retention-period callers already relied on.
 */
export const millisecondsToDays = (milliseconds: number) => Math.floor(milliseconds / millisecondsInDay);
